export const friendshipExp = [1000, 1550, 2050, 2600, 3175, 3750, 4350, 4975, 5650];

export const commissionExp = [
  25,
  25,
  25,
  25,
  30,
  30,
  30,
  30,
  30,
  35,
  35,
  35,
  35,
  35,
  35,
  35,
  35,
  35,
  35,
  40,
  40,
  40,
  40,
  40,
  45,
  45,
  45,
  45,
  45,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  50,
  55,
  55,
  55,
  55,
  55,
  60,
  60,
  60,
  60,
  60,
];

export const commissionBonusExp = [
  45,
  45,
  45,
  45,
  55,
  55,
  55,
  55,
  55,
  55,
  55,
  55,
  55,
  65,
  65,
  65,
  65,
  65,
  70,
  70,
  70,
  70,
  70,
  75,
  75,
  75,
  75,
  75,
  75,
  85,
  85,
  85,
  85,
  85,
  85,
  85,
  85,
  85,
  85,
  95,
  95,
  95,
  95,
  95,
  100,
  100,
  100,
  100,
  100,
];
